/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Button } from "../../../b";
import { FormikContext } from 'formik';
import "./styles.scss";

// Local Definitions

const componentClassName = 'debugger';

/**
 * This is the component description.
 */
const Debugger = ({
  id,
  className: userClassName,
  style,
  initialIsOpen
  // ...otherProps
}) => {
  const [isOpen, setIsOpen] = useState(initialIsOpen);
  const toggleDebugger = () => setIsOpen(!isOpen);
  const formikContext = useContext(FormikContext);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [componentClassName, userClassName].filter(e => e).join(' '),
    style: style
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: toggleDebugger,
    color: "main2"
  }, isOpen ? 'Close FormDebugger' : 'Open FormDebugger'), isOpen && /*#__PURE__*/React.createElement("pre", {
    className: "debuger-content"
  }, JSON.stringify(formikContext, null, 2)));
};
Debugger.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * state to control the opening and closing of the debugger
   */
  initialIsOpen: PropTypes.bool
};
Debugger.defaultProps = {
  initialIsOpen: false
};
export default Debugger;